import React, { useContext, useRef } from 'react';
import { Link } from 'react-router-dom';
import useRememberPosition from 'components/Dashboard/hooks/useRememberPosition';
import TagsLists from 'components/Dashboard/TagsList';
import { store } from 'components/Store';
import useItemController from 'components/Dashboard/ItemController/useItemController';
import GeneralItemActions from 'components/Dashboard/ItemController/GeneralItemActions';
import createMarkup from 'components/Dashboard/helpers/createMarkup';
import usePositionBodySnippet from 'components/Dashboard/hooks/usePositionBodySnippet';
import ContentTypeBadge from 'components/Dashboard/components/ContentTypeBadge';
import PriorityBadge from 'components/Dashboard/ItemController/PriorityBadge';
import time from 'utils/time';
import RatingUpdateBadge from 'components/Dashboard/PriorityUpdates/RatingUpdateBadge';
import TransformFromPascalCase from 'components/Settings/Utilities/TransformFromPascalCase';
import preventLink from 'components/Dashboard/TagsList/prevenLink';

const LibraryMaterialItem = (props) => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { search } = state;
  const { list, activeSearch } = search;

  const {
    item,
    scrollBarRef,
    index,
    feedItemFlags,
    itemOnclick,
    hideYellowDot,
    showContentTypeBadge,
    notShowShare,
    thumbDownProps,
    tagsFixedPosition,
    itemActionsProps,
    onlyEmbargoedTag,
    tooltipText,
    showPriorityBadge,
    setActiveUpdate,
  } = props;
  const { contentUrl, title, dateTime, articleTypes } = item;

  const titleBodyComponent = useRef(null);
  const { bodySnippet } = usePositionBodySnippet({ titleBodyComponent, item });
  const { rememberPosition } = useRememberPosition();

  const { unseenConditional, locationDescriptor, priorityBadgeCondition, rateUpdatesMode } = useItemController({
    item,
    index,
    hideYellowDot,
    thumbDownProps,
    showPriorityBadge,
    propsFeedItemFlags: props.feedItemFlags,
  });

  return (
    <Link
      to={locationDescriptor(contentUrl)}
      onClick={(e) => {
        if (rateUpdatesMode && setActiveUpdate) {
          preventLink(e);
          setActiveUpdate({ ...item, importanceRating: feedItemFlags?.[index]?.importanceRating });
          return;
        }
        if (scrollBarRef) {
          rememberPosition('LibraryMaterial', scrollBarRef, index);
        }
        if (itemOnclick) {
          itemOnclick(e);
        }
      }}
      data-tooltip-content={tooltipText}
      data-tooltip-id={'general-tooltip'}
      data-tooltip-class-name='header-tooltip'
      data-tooltip-place='top'
    >
      <li className={`my-2 content-item`}>
        {unseenConditional && (
          <>
            <span className='unseen-dot' />
          </>
        )}
        <div className='px-4 py-3'>
          <div className='d-flex align-items-baseline justify-content-between mb-2'>
            {showContentTypeBadge ? (
              <div className='mt-1 specific-bottom-margin-4 flex-grow-1 text-light-blue blue-icon content-type-badge flex-centered justify-content-between'>
                <ContentTypeBadge objectType={item.type} name={'Library material'} />
              </div>
            ) : (
              <h4 className={`mb-0 flex-grow-1 content-item-title`}>{title}</h4>
            )}
            {!notShowShare && (
              <div className='flex-centered'>
                {rateUpdatesMode ? (
                  <>
                    {feedItemFlags?.[index]?.importanceRating && (
                      <RatingUpdateBadge
                        item={{ rating: TransformFromPascalCase(feedItemFlags?.[index]?.importanceRating) }}
                      />
                    )}
                  </>
                ) : (
                  <>
                    {priorityBadgeCondition && <PriorityBadge item={item} feedItemFlags={feedItemFlags[index]} />}
                    <GeneralItemActions
                      item={item}
                      index={index}
                      thumbDownProps={thumbDownProps}
                      itemActionsProps={itemActionsProps}
                    />
                  </>
                )}
              </div>
            )}
          </div>
          {showContentTypeBadge && <h4 className={`mb-2 flex-grow-1 content-item-title`}>{title}</h4>}

          <div className={`content-title w-100`}>
            <p className='heading-date mb-0'>
              {articleTypes?.join(', ')}
              <span className='dot' />
              <span className='date'>{time(dateTime).formatLongDate()}</span>
            </p>
            <p
              className='title-body my-2 position-relative'
              ref={titleBodyComponent}
              dangerouslySetInnerHTML={createMarkup(bodySnippet)}
            />
          </div>

          {list !== null && activeSearch && (
            <TagsLists
              {...props}
              feedItemFlags={feedItemFlags}
              index={index}
              section={'LibraryMaterial'}
              tagsFixedPosition={tagsFixedPosition}
              scrollBarRef={scrollBarRef}
              onlyEmbargoedTag={onlyEmbargoedTag}
            />
          )}
        </div>
      </li>
    </Link>
  );
};
export default LibraryMaterialItem;
